import { render, staticRenderFns } from "./XAutocomplete.vue?vue&type=template&id=70251000&scoped=true"
import script from "./XAutocomplete.vue?vue&type=script&lang=js"
export * from "./XAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70251000",
  null
  
)

export default component.exports